<template>
	<div>
		
		<div class="forget-password">
		    <div id="content">
		      <h3>{{message}}</h3>
		      <el-form :rules="rules" label-width="40px" class="demo-ruleForm">
		        <el-form-item label="邮箱" prop="pass">
		          <el-input type="input" v-model="email" autocomplete="off"></el-input>
		        </el-form-item>
		        <el-form-item>
		          <el-button type="primary" @click="sumbitForm">确定</el-button>
		          <el-button type="primary" @click="cancle">取消</el-button>
		        </el-form-item>
		      </el-form>
		    </div>
		  </div>

	</div>
</template>

<script>
	import axios from "axios";
	export default {
	  name: "forget-password",
	  data() {
	    return {
	      message: "找回密码！",
	      email: "",
	      rules: {
	        email: [{ message: "邮箱不能为空", trigger: "blur" }]
	      }
	    };
	  },
	  methods: {
	    sumbitForm() {
	      if (!this.email) {
	        this.$message.error("请输入邮箱！");
	        return;
	      } else {
	        var reg = /^(?:\w+\.?)*\w+@(?:\w+\.)*\w+$/;
	        if (!reg.test(this.email)) {
	          this.$message.error("邮箱格式不正确，请重新输入！");
	          this.email.focus();
	          return false;
	        } else {
	          this.$message("发送邮件");
	          //    axios
	          //     .post("/register/", {
	          //       name: this.user.username,
	          //       email: this.user.email,
	          //       password: this.user.password
	          //     })
	          //     .then(res => {
	          //       // console.log("111输出response.data", res.data);
	          //       // console.log("111输出response.data.status", res.data.status);
	          //       if (res.data.status === 200) {
	          //         this.$router.push({ path: "/" });
	          //       } else {
	          //         alert("您输入的用户名已存在！");
	          //       }
	          //     });
	        }
	      }
	    },
	    cancle() {
	      this.$router.go(-1);
	    }
	  }
	};

</script>

<style scoped="">
	.forget-password {
	  position: fixed;
	  width: 100%;
	  height: 100%;
	  /* background: url("../assets/images/bg4.png") no-repeat; */
	  background-size: cover;
	  top: 0px;
	  left: 0px;
	  overflow: hidden;
	}
	 
	#content {
	  width: 400px;
	  height: 200px;
	  margin: 100px auto;
	  /* background: #d7e695; */
	  background-color: rgba(0, 0, 0, 0.2);
	  padding: 10px;
	  border-radius: 6px;
	}
</style>
